/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description: 添加隐患按钮组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-08-08 15:57:27
 */
import React, { useCallback } from 'react'
import { Typography } from 'antd'
import { useHazardItems } from '../hooks/useHazardItems'
import { useSensorTracking } from '../hooks/useSensorTracking'

const { Text } = Typography

/**
 * 添加隐患按钮组件 Props 接口
 */
interface XCAddHazardButtonProps {
  /** 点击回调函数 */
  onClick?: () => void
}

/**
 * 添加隐患按钮组件
 * 用于在识别结果中添加新的隐患项
 */
const AddHazardButton: React.FC<XCAddHazardButtonProps> = React.memo(
  ({ onClick }) => {
    const { addHazardItem } = useHazardItems()
    const { reportAISafetyHazardsClick } = useSensorTracking()

    /**
     * 处理点击事件
     */
    const handleClick = useCallback(() => {
      // 上报添加隐患埋点
      reportAISafetyHazardsClick({ clickItem: 'addHazard' })

      // 添加空的隐患项
      addHazardItem('')

      // 执行外部回调
      onClick && onClick()
    }, [addHazardItem, reportAISafetyHazardsClick, onClick])

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          cursor: 'pointer',
          marginBottom: 20
        }}
        onClick={handleClick}
      >
        <div
          style={{
            width: '21px',
            height: '21px',
            backgroundColor: '#0073FF',
            borderRadius: '2.625px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
          }}
        >
          {/* 水平线 */}
          <div
            style={{
              position: 'absolute',
              width: '13.13px',
              height: '2.63px',
              backgroundColor: '#FFFFFF',
              top: '9.19px',
              left: '3.94px'
            }}
          />
          {/* 垂直线 */}
          <div
            style={{
              position: 'absolute',
              width: '2.63px',
              height: '13.13px',
              backgroundColor: '#FFFFFF',
              top: '3.94px',
              left: '9.19px'
            }}
          />
        </div>
        <Text
          style={{
            fontFamily: 'PingFang SC',
            fontWeight: 600,
            fontSize: '17px',
            lineHeight: '24px',
            color: '#0070F4'
          }}
        >
          补充遗漏的隐患，帮助AI训练
        </Text>
      </div>
    )
  }
)

export default AddHazardButton
